export const Errors = {
    internalError: {
        message: 'Internal error',
        code: 'internal_error'
    },
    notFound: {
        message: 'Resource not found',
        code: 'resource_not_found'
    },
    alreadyExist: {
        message: 'Resource already exist',
        code: 'already_exist'
    },
    unauthorized: {
        message: 'You do not have sufficient permissions',
        code: 'unauthorized'
    },
    serviceUnavaliable: {
        message: 'Service unavaliable',
        code: 'service_unavaliable',
        retryable: true
    },
    invalidAmountCurrency: {
        message: 'Invalid amountCurrency',
        code: 'invalid_amount_currency'
    },
    invalidTradingPair: {
        message: 'Invalid trading pair',
        code: 'invalid_trading_pair'
    },
    transactionAmountOverLimit: {
        message: 'Transaction amout exceeded limit',
        code: 'transaction_amount_over_limit'
    },
    noBalanceAvailable: {
        message: 'Not enough funds',
        code: 'no_balance_available'
    },
    chargeNotPaid: {
        message: 'Charge has not been paid',
        code: 'charge_not_paid'
    },
    chargePaymentPending: {
        message: 'Charge is pending',
        code: 'charge_payment_pending'
    },
    chargePaymentExpired: {
        message: 'Charge is expired',
        code: 'charge_payment_expired'
    },
    chargeNotRefundablePayment: {
        message: 'Charge is not refundable',
        code: 'charge_not_refundable'
    },
    missingClientData: {
        message: 'Client KYC data is missing, but your account specify it as needed',
        code: 'missing_client_data'
    },
    maximumAmountOfCardsReached: {
        message: 'Maximum amount of card reached',
        code: 'card_max_reached'
    },
    cardCannotCancel: {
        message: 'Card can not be canceled',
        code: 'card_cannot_be_canceled'
    },
    cardInvalidCountry: {
        message: 'Invalid country',
        code: 'card_invalid_country'
    },
    cardNotAllowedCountry: {
        message: 'Service not allowed in the specified country',
        code: 'country_not_allowed'
    },
    cardInsufficientFunds: {
        message: `The account doesn't have enough funds for this operation`,
        code: 'card_insufficient_funds'
    },
    cardChargingFiatFee: {
        message: 'Error charging fiat fee',
        code: 'card_charging_fiat_fee'
    },
    cardIsCanceled: {
        message: 'Card is canceled',
        code: 'card_is_canceled'
    },
    cardIsNotActive: {
        message: 'Card is not active',
        code: 'card_is_not_active'
    },
    cardCannotActivate: {
        message: 'Card cannot be activated',
        code: 'card_cannot_be_activated'
    },
    cardIsActive: {
        message: 'Card is active',
        code: 'card_is_active'
    },
    cardIsPending: {
        message: 'Card is pending',
        code: 'card_is_pending'
    },
    cardUserMissingResidenceProof: {
        message: "User's residence proof is missing or invalid",
        code: 'residence_proof_missing'
    },
    cardUserMissingBiometricKyc: {
        message: "User's is not verified biometrically",
        code: 'invalid_biometric_kyc'
    },
    invalidCardPin: {
        message: 'The provided pin is incorrect',
        code: 'card_pin_is_invalid'
    },
    invalidExpiryDate: {
        message: 'The provided date is incorrect',
        code: 'card_expiry_date_is_invalid'
    },
    invalidProviderCardId: {
        message: 'The provided id is incorrect',
        code: 'card_provider_id_is_invalid'
    },
    noBusinessAccount: {
        message: 'The account is not business account',
        code: 'no_business_account'
    },
    noVerfiedAccount: {
        message: 'The account is not verified',
        code: 'no_verfied_account'
    },
    futuresExpiredOffer: {
        message: 'This offer has already expired',
        code: 'futures_expired_offer'
    },
    futuresAmountTooHigh: {
        message: 'Required amount is too high',
        code: 'futures_amount_too_high'
    },
    futuresAmountTooLow: {
        message: 'Required amount is too low',
        code: 'futures_amount_too_low'
    },
    savingsAmountTooHigh: {
        message: 'Required amount is too high',
        code: 'savings_amount_too_high'
    },
    savingsAmountTooLow: {
        message: 'Required amount is too low',
        code: 'savings_amount_too_low'
    },
    futuresInvalidAmount: {
        message: 'Invalid amount',
        code: 'futures_invalid_amount'
    },
    futuresInvalidExpirationDate: {
        message: 'The future must not expire in the past',
        code: 'futures_invalid_expiration_date'
    },
    stakingInvalidAmount: {
        message: 'The amount must be between 0.001 and 32 ETH',
        code: 'invalid_staking_amount'
    },
    stakingInvalidNodePublicKey: {
        message: 'Invalid node public key',
        code: 'invalid_node_public_key'
    },
    stakingInsufficientEthBalance: {
        message: 'Insufficient ETH balance',
        code: 'insufficient_eth_balance'
    },
    orderCanNotBeCanceled: {
        message: 'Order can no be canceled',
        code: 'order_can_not_be_canceled'
    },
    orderCanNotBeCreated: {
        message: 'Order can no be created',
        code: 'order_can_not_be_created'
    },
    orderOnlyCanceled: {
        message: 'Order can only be canceled',
        code: 'order_can_only_be_canceled'
    },
    invalidPromoCode: {
        message: 'Promo code is invalid',
        code: 'invalid_promo_code'
    },
    hotWalletNotEnoughBalance: {
        message: 'Hot wallet has not enough balance',
        code: 'hot_wallet_not_enough_balance'
    },
    hotWalletInvalidCurrency: {
        message: 'Invalid currency for hot wallet',
        code: 'hot_wallet_invalid_currency'
    },
    hotWalletNotEnoughEther: {
        message: 'Hot wallet has not enough ether to pay the gas to transfer ERC20 tokens',
        code: 'hot_wallet_not_enough_ether'
    },
    requireOtp: {
        message: 'Required otp',
        code: 'require_otp'
    },
    invalidOtp: {
        message: 'invalid otp',
        code: 'invalid_otp'
    },
    withdrawalInsufficientFunds: {
        message: 'Insufficient funds',
        code: 'withdrawal_insufficient_funds'
    },
    withdrawalInvalidAddress: {
        message: 'Invalid address',
        code: 'withdrawal_invalid_address'
    },
    notEnoughFunds: {
        message: 'Not enoughs funds in the source account',
        code: 'not_enough_funds'
    },
    codeReedemed: {
        message: 'Promo code has been redeemed',
        code: 'promo_code_redeemed'
    },
    codeMaxUsage: {
        message: 'Promo code has reached usage limit',
        code: 'promo_code_max_usage'
    },
    userHasReferral: {
        message: 'User has already a referral',
        code: 'user_has_already_referral'
    },
    invalidReferralCode: {
        message: 'Invalid referral code',
        code: 'invalid_referral_code'
    },
    referrerCodesLimitReached: {
        message: 'Referrer code has reached the limit',
        code: 'referrer_code_limit_reached'
    },
    savingsInvalidOffer: {
        message: 'Invalid offer',
        code: 'savings_invalid_offer'
    },
    invalidAmount: {
        message: 'Invalid amount',
        code: 'invalid_amount'
    },
    invalidCountryCode: {
        message: 'Invalid country code',
        code: 'invalid_country_code'
    },
    exceedRestrictedChargeAmount: {
        message: 'Charge exceeds maximum charge amount',
        code: 'exceed_restricted_charge_amount'
    },
    verifiedUser: {
        message: 'Verified user',
        code: 'verified_user'
    },
    invalidPhoneNumber: {
        message: 'Invalid phone number',
        code: 'invalid_phone'
    },
    invalidExtensionFile: {
        message: 'Extension file not supported',
        code: 'invalid_extension_file'
    },
    invalidSizeFile: {
        message: 'File is too large',
        code: 'invalid_size_file'
    }
};
export const countries = {
    AI: {
        code: 'AI',
        name: 'Anguilla',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    AD: {
        code: 'AD',
        name: 'Andorra',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    AT: {
        code: 'AT',
        name: 'Austria',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    BE: {
        code: 'BE',
        name: 'Belgium',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    BG: {
        code: 'BG',
        name: 'Bulgaria',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    HR: {
        code: 'HR',
        name: 'Croatia',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    CY: {
        code: 'CY',
        name: 'Cyprus',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    CZ: {
        code: 'CZ',
        name: 'Czech Republic',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    DK: {
        code: 'DK',
        name: 'Denmark',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    EE: {
        code: 'EE',
        name: 'Estonia',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    FI: {
        code: 'FI',
        name: 'Finland',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    FR: {
        code: 'FR',
        name: 'France',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    DE: {
        code: 'DE',
        name: 'Germany',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    GR: {
        code: 'GR',
        name: 'Greece',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    IE: {
        code: 'IE',
        name: 'Ireland',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    IT: {
        code: 'IT',
        name: 'Italy',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    LV: {
        code: 'LV',
        name: 'Latvia',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    LT: {
        code: 'LT',
        name: 'Lithuania',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    LU: {
        code: 'LU',
        name: 'Luxembourg',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    NL: {
        code: 'NL',
        name: 'Netherlands',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    NO: {
        code: 'NO',
        name: 'Norway',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    PT: {
        code: 'PT',
        name: 'Portugal',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    SK: {
        code: 'SK',
        name: 'Slovakia',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    SI: {
        code: 'SI',
        name: 'Slovenia',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    ES: {
        code: 'ES',
        name: 'Spain',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    SE: {
        code: 'SE',
        name: 'Sweden',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    CH: {
        code: 'CH',
        name: 'Switzerland',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    GB: {
        code: 'GB',
        name: 'United Kingdom',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    KR: {
        code: 'KR',
        name: 'Korea, Republic of',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    AX: {
        code: 'AX',
        name: '\u00c5land Islands',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    AO: {
        code: 'AO',
        name: 'Angola',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    AR: {
        code: 'AR',
        name: 'Argentina',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    AM: {
        code: 'AM',
        name: 'Armenia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    AW: {
        code: 'AW',
        name: 'Aruba',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    AU: {
        code: 'AU',
        name: 'Australia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    BH: {
        code: 'BH',
        name: 'Bahamas',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    BZ: {
        code: 'BZ',
        name: 'Belize',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    BJ: {
        code: 'BJ',
        name: 'Benin',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    BT: {
        code: 'BT',
        name: 'Bhutan',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    BO: {
        code: 'BO',
        name: 'Bolivia, Plurinational State of',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    BW: {
        code: 'BW',
        name: 'Botswana',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    BR: {
        code: 'BR',
        name: 'Brazil',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    BI: {
        code: 'BI',
        name: 'Burundi',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CM: {
        code: 'CM',
        name: 'Cameroon',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CA: {
        code: 'CA',
        name: 'Canada',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CV: {
        code: 'CV',
        name: 'Cape Verde',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CF: {
        code: 'CF',
        name: 'Central African Republic',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TD: {
        code: 'TD',
        name: 'Chad',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CL: {
        code: 'CL',
        name: 'Chile',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CO: {
        code: 'CO',
        name: 'Colombia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    KM: {
        code: 'KM',
        name: 'Comoros',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CG: {
        code: 'CG',
        name: 'Congo',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CD: {
        code: 'CD',
        name: 'Congo, the Democratic Republic of the',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CR: {
        code: 'CR',
        name: 'Costa Rica',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CI: {
        code: 'CI',
        name: "C\u00f4te d'Ivoire",
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    CW: {
        code: 'CW',
        name: 'Cura\u00e7ao',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    DO: {
        code: 'DO',
        name: 'Dominican Republic',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    EC: {
        code: 'EC',
        name: 'Ecuador',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    SV: {
        code: 'SV',
        name: 'El Salvador',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    GQ: {
        code: 'GQ',
        name: 'Equatorial Guinea',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    GA: {
        code: 'GA',
        name: 'Gabon',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    GM: {
        code: 'GM',
        name: 'Gambia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    GE: {
        code: 'GE',
        name: 'Georgia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    GH: {
        code: 'GH',
        name: 'Ghana',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    GN: {
        code: 'GN',
        name: 'Guinea',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    GW: {
        code: 'GW',
        name: 'Guinea-Bissau',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    VA: {
        code: 'VA',
        name: 'Holy See (Vatican City State)',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    HN: {
        code: 'HN',
        name: 'Honduras',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    HU: {
        code: 'HU',
        name: 'Hungary',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    IS: {
        code: 'IS',
        name: 'Iceland',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    IN: {
        code: 'IN',
        name: 'India',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    KZ: {
        code: 'KZ',
        name: 'Kazakhstan',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    KI: {
        code: 'KI',
        name: 'Kiribati',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    KW: {
        code: 'KW',
        name: 'Kuwait',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    KG: {
        code: 'KG',
        name: 'Kyrgyzstan',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    LS: {
        code: 'LS',
        name: 'Lesotho',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    LY: {
        code: 'LY',
        name: 'Libya',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MK: {
        code: 'MK',
        name: 'Macedonia, the Former Yugoslav Republic of',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MG: {
        code: 'MG',
        name: 'Madagascar',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MW: {
        code: 'MW',
        name: 'Malawi',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MY: {
        code: 'MY',
        name: 'Malaysia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MV: {
        code: 'MV',
        name: 'Maldives',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MR: {
        code: 'MR',
        name: 'Mauritania',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    YT: {
        code: 'YT',
        name: 'Mayotte',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MX: {
        code: 'MX',
        name: 'Mexico',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MD: {
        code: 'MD',
        name: 'Moldova, Republic of',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MN: {
        code: 'MN',
        name: 'Mongolia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    ME: {
        code: 'ME',
        name: 'Montenegro',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MZ: {
        code: 'MZ',
        name: 'Mozambique',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    NA: {
        code: 'NA',
        name: 'Namibia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    NR: {
        code: 'NR',
        name: 'Nauru',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    NP: {
        code: 'NP',
        name: 'Nepal',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    NZ: {
        code: 'NZ',
        name: 'New Zealand',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    NU: {
        code: 'NU',
        name: 'Niue',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    PS: {
        code: 'PS',
        name: 'Palestine, State of',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    PG: {
        code: 'PG',
        name: 'Papua New Guinea',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    PY: {
        code: 'PY',
        name: 'Paraguay',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    PE: {
        code: 'PE',
        name: 'Peru',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    PL: {
        code: 'PL',
        name: 'Poland',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    PR: {
        code: 'PR',
        name: 'Puerto Rico',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    RO: {
        code: 'RO',
        name: 'Romania',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    RW: {
        code: 'RW',
        name: 'Rwanda',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    MF: {
        code: 'MF',
        name: 'Saint Martin (French part)',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    SM: {
        code: 'SM',
        name: 'San Marino',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    ST: {
        code: 'ST',
        name: 'Sao Tome and Principe',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    RS: {
        code: 'RS',
        name: 'Serbia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    SL: {
        code: 'SL',
        name: 'Sierra Leone',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    SG: {
        code: 'SG',
        name: 'Singapore',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    SO: {
        code: 'SO',
        name: 'Somalia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    ZA: {
        code: 'ZA',
        name: 'South Africa',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    LK: {
        code: 'LK',
        name: 'Sri Lanka',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    SR: {
        code: 'SR',
        name: 'Suriname',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    SZ: {
        code: 'SZ',
        name: 'Swaziland',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TJ: {
        code: 'TJ',
        name: 'Tajikistan',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TZ: {
        code: 'TZ',
        name: 'Tanzania, United Republic of',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TH: {
        code: 'TH',
        name: 'Thailand',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TL: {
        code: 'TL',
        name: 'Timor-Leste',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TG: {
        code: 'TG',
        name: 'Togo',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TO: {
        code: 'TO',
        name: 'Tonga',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TM: {
        code: 'TM',
        name: 'Turkmenistan',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TV: {
        code: 'TV',
        name: 'Tuvalu',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    AE: {
        code: 'AE',
        name: 'United Arab Emirates',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    UY: {
        code: 'UY',
        name: 'Uruguay',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    UZ: {
        code: 'UZ',
        name: 'Uzbekistan',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    VN: {
        code: 'VN',
        name: 'Viet Nam',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    WF: {
        code: 'WF',
        name: 'Wallis and Futuna',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    ZM: {
        code: 'ZM',
        name: 'Zambia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    JP: {
        code: 'JP',
        name: 'Japan',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    KE: {
        code: 'KE',
        name: 'Kenya',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    NE: {
        code: 'NE',
        name: 'Niger',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    SA: {
        code: 'SA',
        name: 'Saudi Arabia',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TW: {
        code: 'TW',
        name: 'Taiwan, Province of China',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    US: {
        code: 'US',
        name: 'United States',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    AF: {
        code: 'AF',
        name: 'Afghanistan',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    AL: {
        code: 'AL',
        name: 'Albania',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    DZ: {
        code: 'DZ',
        name: 'Algeria',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    AQ: {
        code: 'AQ',
        name: 'Antarctica',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    AS: {
        code: 'AS',
        name: 'American Samoa',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    AZ: {
        code: 'AZ',
        name: 'Azerbaijan',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    AG: {
        code: 'AG',
        name: 'Antigua and Barbuda',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BD: {
        code: 'BD',
        name: 'Bangladesh',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BB: {
        code: 'BB',
        name: 'Barbados',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BS: {
        code: 'BS',
        name: 'Bahrain',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BQ: {
        code: 'BQ',
        name: 'Bonaire, Sint Eustatius and Saba',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BA: {
        code: 'BA',
        name: 'Bosnia and Herzegovina',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BV: {
        code: 'BV',
        name: 'Bouvet Island',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    IO: {
        code: 'IO',
        name: 'British Indian Ocean Territory',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BM: {
        code: 'BM',
        name: 'Bermuda',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BF: {
        code: 'BF',
        name: 'Burkina Faso',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    KH: {
        code: 'KH',
        name: 'Cambodia',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    KY: {
        code: 'KY',
        name: 'Cayman Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    CN: {
        code: 'CN',
        name: 'China',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    CX: {
        code: 'CX',
        name: 'Christmas Island',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    CC: {
        code: 'CC',
        name: 'Cocos (Keeling) Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BN: {
        code: 'BN',
        name: 'Brunei Darussalam',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    CU: {
        code: 'CU',
        name: 'Cuba',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    DJ: {
        code: 'DJ',
        name: 'Djibouti',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    CK: {
        code: 'CK',
        name: 'Cook Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    EG: {
        code: 'EG',
        name: 'Egypt',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    ER: {
        code: 'ER',
        name: 'Eritrea',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    ET: {
        code: 'ET',
        name: 'Ethiopia',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    DM: {
        code: 'DM',
        name: 'Dominica',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    FO: {
        code: 'FO',
        name: 'Faroe Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    FK: {
        code: 'FK',
        name: 'Falkland Islands (Malvinas)',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    GF: {
        code: 'GF',
        name: 'French Guiana',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    PF: {
        code: 'PF',
        name: 'French Polynesia',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    TF: {
        code: 'TF',
        name: 'French Southern Territories',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    FJ: {
        code: 'FJ',
        name: 'Fiji',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    GL: {
        code: 'GL',
        name: 'Greenland',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    GI: {
        code: 'GI',
        name: 'Gibraltar',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    GP: {
        code: 'GP',
        name: 'Guadeloupe',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    GT: {
        code: 'GT',
        name: 'Guatemala',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    GD: {
        code: 'GD',
        name: 'Grenada',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    GY: {
        code: 'GY',
        name: 'Guyana',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    HT: {
        code: 'HT',
        name: 'Haiti',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    HM: {
        code: 'HM',
        name: 'Heard Island and McDonald Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    HK: {
        code: 'HK',
        name: 'Hong Kong',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    ID: {
        code: 'ID',
        name: 'Indonesia',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    IR: {
        code: 'IR',
        name: 'Iran',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    IQ: {
        code: 'IQ',
        name: 'Iraq',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    IM: {
        code: 'IM',
        name: 'Isle of Man',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    IL: {
        code: 'IL',
        name: 'Israel',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    JM: {
        code: 'JM',
        name: 'Jamaica',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    GU: {
        code: 'GU',
        name: 'Guam',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    GG: {
        code: 'GG',
        name: 'Guernsey',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    KP: {
        code: 'KP',
        name: "Korea, Democratic People's Republic of",
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    LA: {
        code: 'LA',
        name: "Lao People's Democratic Republic",
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    JE: {
        code: 'JE',
        name: 'Jersey',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    JO: {
        code: 'JO',
        name: 'Jordan',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    LB: {
        code: 'LB',
        name: 'Lebanon',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    LR: {
        code: 'LR',
        name: 'Liberia',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    ML: {
        code: 'ML',
        name: 'Mali',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    MT: {
        code: 'MT',
        name: 'Malta',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    MH: {
        code: 'MH',
        name: 'Marshall Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    MQ: {
        code: 'MQ',
        name: 'Martinique',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    LI: {
        code: 'LI',
        name: 'Liechtenstein',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    FM: {
        code: 'FM',
        name: 'Micronesia, Federated States of',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    MO: {
        code: 'MO',
        name: 'Macao',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    MU: {
        code: 'MU',
        name: 'Mauritius',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    MA: {
        code: 'MA',
        name: 'Morocco',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    MM: {
        code: 'MM',
        name: 'Myanmar',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    NC: {
        code: 'NC',
        name: 'New Caledonia',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    NI: {
        code: 'NI',
        name: 'Nicaragua',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    NG: {
        code: 'NG',
        name: 'Nigeria',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    NF: {
        code: 'NF',
        name: 'Norfolk Island',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    MC: {
        code: 'MC',
        name: 'Monaco',
        lite: false,
        isSepa: true,
        isHighRisk: false
    },
    OM: {
        code: 'OM',
        name: 'Oman',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    PK: {
        code: 'PK',
        name: 'Pakistan',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    PW: {
        code: 'PW',
        name: 'Palau',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    PA: {
        code: 'PA',
        name: 'Panama',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    PH: {
        code: 'PH',
        name: 'Philippines',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    PN: {
        code: 'PN',
        name: 'Pitcairn',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    QA: {
        code: 'QA',
        name: 'Qatar',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    RE: {
        code: 'RE',
        name: 'R\u00e9union',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    RU: {
        code: 'RU',
        name: 'Russian Federation',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BL: {
        code: 'BL',
        name: 'Saint Barth\u00e9lemy',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    SH: {
        code: 'SH',
        name: 'Saint Helena, Ascension and Tristan da Cunha',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    KN: {
        code: 'KN',
        name: 'Saint Kitts and Nevis',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    MS: {
        code: 'MS',
        name: 'Montserrat',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    PM: {
        code: 'PM',
        name: 'Saint Pierre and Miquelon',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    MP: {
        code: 'MP',
        name: 'Northern Mariana Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    SN: {
        code: 'SN',
        name: 'Senegal',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    LC: {
        code: 'LC',
        name: 'Saint Lucia',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    SX: {
        code: 'SX',
        name: 'Sint Maarten (Dutch part)',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    VC: {
        code: 'VC',
        name: 'Saint Vincent and the Grenadines',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    GS: {
        code: 'GS',
        name: 'South Georgia and the South Sandwich Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    SS: {
        code: 'SS',
        name: 'South Sudan',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    SD: {
        code: 'SD',
        name: 'Sudan',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    SJ: {
        code: 'SJ',
        name: 'Svalbard and Jan Mayen',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    SY: {
        code: 'SY',
        name: 'Syrian Arab Republic',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    TK: {
        code: 'TK',
        name: 'Tokelau',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    TN: {
        code: 'TN',
        name: 'Tunisia',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    TR: {
        code: 'TR',
        name: 'Turkey',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    WS: {
        code: 'WS',
        name: 'Samoa',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    SC: {
        code: 'SC',
        name: 'Seychelles',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    UA: {
        code: 'UA',
        name: 'Ukraine',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    UM: {
        code: 'UM',
        name: 'United States Minor Outlying Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    UG: {
        code: 'UG',
        name: 'Uganda',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    VE: {
        code: 'VE',
        name: 'Venezuela, Bolivarian Republic of',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    SB: {
        code: 'SB',
        name: 'Solomon Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    TT: {
        code: 'TT',
        name: 'Trinidad and Tobago',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    EH: {
        code: 'EH',
        name: 'Western Sahara',
        lite: true,
        isSepa: false,
        isHighRisk: false
    },
    TC: {
        code: 'TC',
        name: 'Turks and Caicos Islands',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    YE: {
        code: 'YE',
        name: 'Yemen',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    VU: {
        code: 'VU',
        name: 'Vanuatu',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    BY: {
        code: 'BY',
        name: 'Belarus',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    VG: {
        code: 'VG',
        name: 'Virgin Islands, British',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    VI: {
        code: 'VI',
        name: 'Virgin Islands, U.S.',
        lite: false,
        isSepa: false,
        isHighRisk: true
    },
    ZW: {
        code: 'ZW',
        name: 'Zimbabwe',
        lite: false,
        isSepa: false,
        isHighRisk: true
    }
};
export const NoContentResponse = {
    statusCode: 204,
    body: {}
};
export var MatiKycStatus;
(function (MatiKycStatus) {
    MatiKycStatus["reviewNeeded"] = "reviewNeeded";
    MatiKycStatus["expired"] = "expired";
    MatiKycStatus["rejected"] = "rejected";
    MatiKycStatus["verified"] = "verified";
})(MatiKycStatus || (MatiKycStatus = {}));
export var ComplianceFlows;
(function (ComplianceFlows) {
    ComplianceFlows["default"] = "default";
    ComplianceFlows["proofOfResidence"] = "proofOfResidence";
})(ComplianceFlows || (ComplianceFlows = {}));
export var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods["FIAT_BALANCE"] = "fiat-balance";
})(PaymentMethods || (PaymentMethods = {}));
export var TransactionTypes;
(function (TransactionTypes) {
    TransactionTypes["CRIPTO_BUY"] = "crypto-buy";
    TransactionTypes["CRIPTO_SELL"] = "crypto-sell";
    TransactionTypes["FIAT_CHARGE_BANK_WITHDRAWAL"] = "fiat-charge-bank-withdrawal";
    TransactionTypes["FIAT_WITHDRAWAL"] = "fiat-withdrawal";
    TransactionTypes["CRYPTO_SEND"] = "crypto-send";
})(TransactionTypes || (TransactionTypes = {}));
export var TradeTypes;
(function (TradeTypes) {
    TradeTypes["BUY"] = "buy";
    TradeTypes["SELL"] = "sell";
})(TradeTypes || (TradeTypes = {}));
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["COMPLETED"] = "Completada";
    TransactionStatus["PENDING"] = "Pendiente";
})(TransactionStatus || (TransactionStatus = {}));
export const STAKED_ETH_PER_NODE = 32;
export const EXCHANGE_YIELD_PRODUCTS = {
    stakeEth20: 'STAKE_ETH20',
    futures: 'FUTURES'
};
//# sourceMappingURL=types.js.map